import { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { AxiosError } from "axios";
import Notify from "config/notify";
import { JoyfulStoreSet } from "../types";

const commonTableCellStyles = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontWeight: 500,
  fontSize: 12,
  letterSpacing: "0.01071em",
  display: "table-cell",
  verticalAlign: "inherit",
  borderBottom: "1px solid rgba(224, 224, 224, 1)",
  textAlign: "left",
  padding: "16px",
  paddingTop: "20px",
  paddingBottom: "20px",
  color: "rgba(0, 0, 0, 0)",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  maxWidth: "110px",
  borderLeft: "1px solid rgb(224, 224, 224)",
  borderTop: "1px solid rgb(224, 224, 224)",
};

export interface CompanyDeleteProps {
  open: boolean;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  //   row: JoyfulStoreSet;
}

/**
 * CompanyDeleteModal
 * @param root0 コンポーネントのprops
 * @returns JSX.Element
 */
export default function CompanyDeleteModal({
  open,
  isDeleting,
  onClose,
  onConfirm,
}: CompanyDeleteProps) {
  const handleClose = () => {
    onClose();
  };
  const handleCompanyDelete = async () => {
    try {
      await onConfirm();
      onClose();
    } catch (err) {
      console.error(err);
      const error2 = err as AxiosError;
      // レスポンス自体がなくエラーになった時
      if (!error2.response) {
        Notify.setNotification({
          show: true,
          title: "APIに接続できませんでした。",
          confirmLabel: "OK",
          actionsPosition: "end",
        });
        return;
      }
      const { status } = error2.response;
      const data = error2.response.data as {code: string, message: string};
      switch (status) {
        // case 400:
        //   Notify.setNotification({
        //     show: true,
        //     title: "パラメータエラーです。",
        //     confirmLabel: "OK",
        //     actionsPosition: "end",
        //   });
        //   break;
        case 422:
          Notify.setNotification({
            // show: true,
            // title: data.messages.join('\n'),
            // confirmLabel: "OK",
            // actionsPosition: "end",
            show: true,
            title: "入力エラーがあります。",
            message: data.message,
            titleColor: "var(--error)",
          });
          break;
        default:
          break;
      }
    }
  };

  return (
    <Dialog open={open} onClose={() => handleClose()}>
      <Box p={2}>
        <DialogTitle>企業設定削除</DialogTitle>
        <DialogContent>
          {isDeleting && (
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255, 0.8)",
              }}
            >
              <CircularProgress size={80} />
            </Box>
          )}
          <Typography>企業設定削除します。よろしいですか？</Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="custom-outlined" onClick={() => handleClose()} disabled={false}>
            キャンセル
          </Button>
          <Button
            color="error"
            variant="contained"
            disabled={isDeleting}
            onClick={async () => {
              try {
                await handleCompanyDelete();
              } catch (err) {
                console.error("error", err);
                handleClose();
              }
            }}
          >
            削除
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
